import React from 'react'
import "./cvheader.css"


const Cvheader = () => {
  return (
    <div className='cvheader'>
        <h2>
           CV Repository
        </h2>
        <p>
        Inspiring CVs of Seniors who backed Dream Placements and Internships!<br/>
        </p>
    </div>
  )
}

export default Cvheader
